export const BuildInfo = {timestamp:1784570602000}
